export default __webpack_public_path__ + "static/media/celebrate.43f769def58ae9e374830cc4cd2c0716.svg";